define('features/overlayGameLauncher/stats/xpMilestones/xpMilestonesViewModel',[
    'knockout'
],
function (ko) {

    return function XPMilestonesViewModel (newAdventure, adventureStaticData, parentView, id) {

        var self = this;

        self.id = id || 'xpMilestones';
        self.xp = newAdventure.summary.property('xp');

        self.viewSmall = 'features/overlayGameLauncher/stats/xpMilestones/xpMilestonesViewSmall';
        self.viewLarge = 'features/overlayGameLauncher/stats/xpMilestones/xpMilestonesViewLarge';

        self.cssBinding = ko.pureComputed(function () {
            var css = {
                'xp': true,
                'flex-horizontal': true,
                'milestone': true
            };

            return css;
        });

        self.viewBeltInfo = ko.observable(false);

        self.activate = function () {
            self.viewBeltInfo(false);
        };

        adventureStaticData.apply(this, []);

    };
});

